import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const RoleWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "h4",
    color: "text-core-on-fill-default",
    children: children
  });
};
export const Role = ({
  jobTitle,
  companyName
}) => {
  if (jobTitle && companyName) {
    return /*#__PURE__*/_jsx(RoleWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "profilePage.AcademyProfile.header.roleAtCompany",
        options: {
          jobTitle,
          companyName
        }
      })
    });
  }
  if (jobTitle) {
    return /*#__PURE__*/_jsx(RoleWrapper, {
      children: jobTitle
    });
  }
  if (companyName) {
    return /*#__PURE__*/_jsx(RoleWrapper, {
      children: companyName
    });
  }
  return null;
};